import { TrackingEvent, type FormContext, type StepContext, type UserInputField } from '../types'

export interface FieldInputtedProperties {
  formContext?: FormContext
  stepContext?: StepContext
  userInputField: UserInputField
}

export class FieldInputted extends TrackingEvent {
  properties: FieldInputtedProperties

  constructor(args: FieldInputtedProperties) {
    const {
      formContext = {
        formName: '',
        formType: '',
        formId: '',
      },
      stepContext = {
        stepName: '',
        stepId: '',
        stepNumber: 0,
      },
      userInputField = {
        fieldName: '',
        fieldType: '',
        fieldValue: '',
        fieldLabel: '',
      },
    } = args ?? {}

    super('FieldInputted', 'redventures.usertracking.v3.FieldInputted')

    this.properties = {
      formContext: {
        formName: formContext.formName,
        formType: formContext.formType,
        formId: formContext.formId,
      },
      stepContext: {
        stepName: stepContext.stepName,
        stepId: stepContext.stepId,
        stepNumber: stepContext.stepNumber,
      },
      userInputField: {
        fieldName: userInputField.fieldName ?? '',
        fieldType: userInputField.fieldType ?? '',
        fieldValue: userInputField.fieldValue ?? '',
        fieldLabel: userInputField.fieldLabel ?? '',
        fieldSource: userInputField.fieldSource ?? '',
        autofilled: userInputField.autofilled ?? false,
      },
    }
  }
}
